/** function that checks if users device has a touchscreen
 * used for setting different hover behaviours depending on
 * touchscreen or not. They can get messed up on iOS i particular */
export const isTouchScreenDevice = () => {
    if (typeof window === 'undefined') {
        return false;
    }
    return 'ontouchstart' in window;
};
//# sourceMappingURL=theme-helper.js.map